import { useNavigate } from 'react-router-dom'
import styles from '../../styles/user/ProgressBox.module.scss'
import BaseButton from '../common/BaseButton'
import ProgressStep from '../common/ProgressStep'
import { useAuthStore } from '../../store'
import { useUserStore } from '../../store/useUserStore'
import ProgressBar from '../common/ProgressStep'
import React from 'react'
import { resolveAvatarSrc } from '../../utils/avatar'

const ProgressBox = () => {
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const userProfile = useUserStore((state) => state.userProfile)

  const handleStartTest = () => {
    navigate('/levelTest')
  }

  const userAvatar = resolveAvatarSrc(
    userProfile?.avatarImagePath || user?.AVATAR || ''
  )
  const userName = userProfile?.nickname || user?.NICKNAME || 'User'

  return (
    <div className={styles.userContainer}>
      <div className={styles.avatarWrapper}>
        <img
          src={userAvatar}
          alt="User Avatar"
          className={styles.avatar}
          onError={(e) => {
            e.currentTarget.src = '/assets/avatar/characters/Buddy.png'
          }}
        />
        <div className={styles.userName}>{userName}</div>
      </div>

      <div className={styles.formWrapper}>
        <p className={styles.progressTitle}>Learning Progress</p>
        <ProgressBar percent={72} />
        <div className={styles.progressButtonWrapper}>
          <BaseButton
            className={styles.progressButton}
            onClick={handleStartTest}
          >
            Start
          </BaseButton>
        </div>
      </div>
    </div>
  )
}

export default ProgressBox
